<script setup lang="ts">
import { watch } from 'vue'
import { useCounter, useIdle } from '@vueuse/core'

export interface Props {
  timeout?: number
}

const props = withDefaults(defineProps<Props>(), {
  timeout: 3000,
})

const emit = defineEmits<{
  idleTimeout: [{ count: number; lastActive: number; reset: () => void }]
}>()

const { inc, count } = useCounter()
const { idle, lastActive, reset } = useIdle(props.timeout)

watch(idle, (idleValue) => {
  if (idleValue) {
    inc()
    // console.log(`Triggered ${count.value} times`)
    emit('idleTimeout', { count: count.value, lastActive: lastActive.value, reset })
    reset()
  }
})
</script>

<template></template>
